import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TooltipLoader } from '../../global/TooltipLoader';
import styles from './PdpRespSidebarSellerInfoIcon.scss';

export class PdpRespSidebarSellerInfoIcon extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isVisible: false,
            load: false,
        };
    }

    render() {
        const { title, description, icon: Icon, dataTn } = this.props;
        const { isVisible, load } = this.state;
        const mouseProps = {
            onMouseEnter: () => this.setState({ isVisible: !isVisible, load: true }),
            onMouseLeave: () => this.setState({ isVisible: !isVisible }),
        };

        return (
            <div {...mouseProps} className={styles.wrapper} data-tn={dataTn}>
                <Icon className={styles.icon} />
                <TooltipLoader load={load} isVisible={isVisible} direction="bottom" align="right">
                    <span className={styles.title}>{title}: </span> {description}
                </TooltipLoader>
            </div>
        );
    }
}

PdpRespSidebarSellerInfoIcon.propTypes = {
    title: PropTypes.node.isRequired,
    description: PropTypes.node.isRequired,
    icon: PropTypes.func.isRequired,
    dataTn: PropTypes.string,
};
